import { render } from "./trelloContainer.vue?vue&type=template&id=6234417c&ts=true"
import script from "./trelloContainer.vue?vue&type=script&lang=ts"
export * from "./trelloContainer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__